// // src/api/axiosInstance.js
// import axios from "axios";
// import { baseUrl } from "../config";

// // Get token from localStorage or wherever you store it
// const getToken = () => {
//   return localStorage.getItem("token"); // or sessionStorage or cookie
// };

// // Create instance
// const axiosInstance = axios.create({
//   baseURL: `${baseUrl}`, // Change to your base API
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Interceptor to add token before every request
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = getToken();
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Helper function to handle params vs data
// export const apiRequest = ({ url, method = "GET", params = {}, data = {} }) => {
//   return axiosInstance({
//     url,
//     method,
//     params: method === "GET" ? params : {}, // send params only in GET
//     data: method !== "GET" ? data : {},       // send body in POST/PUT etc.
//   });
// };

// export default axiosInstance;


// src/api/axiosInstance.js
import axios from "axios";
import { baseUrl } from "../config";

const getToken = () => {
  return localStorage.getItem("token");
};

const axiosInstance = axios.create({
  baseURL: `${baseUrl}`,
  // ❌ Remove this hardcoded Content-Type here
  // headers will be added dynamically in interceptor
});

// ✅ Interceptor adds Authorization and optionally Content-Type
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Add Content-Type only if not FormData
    if (
      config.data &&
      !(config.data instanceof FormData) &&
      !config.headers["Content-Type"]
    ) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Handles both GET params and POST/PUT body
export const apiRequest = ({ url, method = "GET", params = {}, data = {}, headers = {} }) => {
  return axiosInstance({
    url,
    method,
    params: method === "GET" ? params : {},
    data: method !== "GET" ? data : {},
    headers, // allow override for multipart/form-data
  });
};

export default axiosInstance;
